import { render, staticRenderFns } from "./header-layout.component.vue?vue&type=template&id=0036b906&scoped=true"
import script from "./header-layout.component.vue?vue&type=script&lang=ts"
export * from "./header-layout.component.vue?vue&type=script&lang=ts"
import style0 from "./header-layout.component.vue?vue&type=style&index=0&id=0036b906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036b906",
  null
  
)

export default component.exports